import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4l-2 2l2 2","key":"svg-0"}],["path",{"d":"M12 4l2 2l-2 2","key":"svg-1"}],["path",{"d":"M8 8l1 -4","key":"svg-2"}],["path",{"d":"M17 6a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7","key":"svg-3"}]]

const IconCodeblock = createReactComponent('outline', 'codeblock', 'Codeblock', __iconNode);

export default IconCodeblock;